
import React from 'react';

interface BusinessLogoProps {
  logoUrl?: string;
  title: string;
}

const BusinessLogo: React.FC<BusinessLogoProps> = ({ logoUrl, title }) => {
  if (!logoUrl) return null;
  
  return (
    <div className="overflow-hidden shrink-0 h-10 w-auto max-w-[80px] ml-2">
      <img 
        src={logoUrl} 
        alt={`${title} logo`} 
        className="h-full w-auto object-contain"
      />
    </div>
  );
};

export default BusinessLogo;
